module.exports = __webpack_public_path__ + "images/117_1024.jpg";